<div *ngIf="simple">
  <select [(ngModel)]="remedyConfigId" (change)="change($event.target.value)">
    <option *ngIf="simpleShowAll" value="">ALL</option>
    <option *ngFor="let remedyConfig of remedyConfigs" [value]="remedyConfig.id">
      {{ remedyConfig.name }} {{remedyConfig.error ? '(BROKEN)' : ''}}
    </option>
  </select>
</div>
<div *ngIf="!simple">
  <mat-form-field>
    <mat-select [(value)]="remedyConfigId" (selectionChange)="change($event.value)" [placeholder]="placeholder" name="remedyConfig" id="remedyConfig" >
      <mat-option *ngFor="let remedyConfig of remedyConfigs" [value]="remedyConfig.id">
        {{ remedyConfig.name }} {{remedyConfig.error ? '(BROKEN)' : ''}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>


